module.exports = __webpack_public_path__ + "static/allgemein2-c71720b281b74e282e11c44995976566.png";